import {getRouteApi} from "@tanstack/react-router";

export const suppliersRouteApi = getRouteApi("/_app/engineering/suppliers/");
